import React from 'react';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import HorseBetting from '../../components/HorseBetting/HorseBetting';
import ComingSoon from '../../components/ComingSoon/ComingSoon';
import SideBar from 'src/components/SideBar/SideBar';
import AccountHistory from 'src/components/Account/AccountHistory/AccountHistory';
import AccountStatement from 'src/components/Account/AccountStatement/AccountStatement';

interface RetailPageProps {
  children?: React.ReactNode,
  childComponent?: string,
  includeBetslip?: boolean
}

const COMPONENTS = { HorseBetting, ComingSoon, AccountHistory, AccountStatement };
export default function RetailPage({ children, childComponent, includeBetslip = false }: RetailPageProps) {
  const ChildComponent = COMPONENTS[childComponent];

  return (
    <div className="page">
      <Header />

      <div className="page__main page__main--retail">
        <div className="page--middle">
          <div className="page__component-wrapper">
            { ChildComponent ? <ChildComponent /> :  children }
          </div>
        </div>
        {
          includeBetslip && <div className="page--right">
            <SideBar sideBar={ 'rightSideBar' } />
          </div>
        }
      </div>

      <Footer />
    </div>
  );
}
